// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CircleLoader_wrap__3MEtp","load8":"CircleLoader_load8__2sL_a"};